import {
    FileOutlined,
    HomeOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UserOutlined,
} from "@ant-design/icons";
import { Grid, Layout, Menu } from "antd";
import { getAccessToken, isLoggedIn } from "axios-jwt";
import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo-512.png";
import { useAppDispatch } from "../../../redux/hooks";
import { DashboardContext } from "../../components/contexts/DashboardContext";
import { ErrorBoundary } from "../../components/ErrorBoundary";
import "../../styles/dashboard/main.css";

const { Header, Sider, Content } = Layout;

export default function Home(props: any) {
    const navigate = useNavigate();
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.lg;
    const [collapsed, setCollapsed] = useState(isMobile);
    const [pageTitle, setPageTitle] = useState("Find policies");
    const dispatch = useAppDispatch();
    const accessToken = getAccessToken();
    const location = useLocation();

    // useEffect(() => {
    //     console.log("location", location.pathname);
    //     // let pageComponents = getPageNameFromLocation(location.pathname);
    //     // setPageTitle(pageComponents);
    // }, [location]);

    useEffect(() => {
        if (!isLoggedIn()) {
            navigate("/");
        } else {
            // Only fetch on initial mount, not when pageNum changes
            // PolicyListSearch component handles fetching with filters
            if (location.pathname === "/") {
                navigate("/home");
            }
        }
    }, [accessToken, dispatch, location.pathname, navigate]);

    return (
        <Layout style={{ minHeight: "100vh", padding: 0, margin: 0 }}>
            <Sider
                hidden={isMobile}
                trigger={null}
                collapsible
                collapsed={collapsed}
                theme="light"
                style={{
                    position: "fixed",
                    left: 0,
                    top: 0,
                    bottom: 0,
                    height: "100vh",
                    overflow: "auto",
                }}
            >
                <div 
                    style={{
                        padding: collapsed ? "16px 8px" : "16px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: collapsed ? "center" : "flex-start",
                        borderBottom: "1px solid #f0f0f0",
                        marginBottom: "8px",
                    }}
                >
                    <img 
                        src={logo} 
                        alt="Logo" 
                        style={{
                            height: collapsed ? "32px" : "40px",
                            width: "auto",
                            objectFit: "contain",
                        }}
                    />
                </div>
                <Menu
                    theme="light"
                    mode="inline"
                    defaultSelectedKeys={["1"]}
                    // selectedKeys={["1"]} // have to manage it yourself if you want to change based on url location
                    items={[
                        {
                            key: "1",
                            icon: <HomeOutlined />,
                            label: (
                                <Link
                                    to={"/home"}
                                    onClick={() => {
                                        setPageTitle("Home");
                                    }}
                                >
                                    Home
                                </Link>
                            ),
                        },
                        {
                            key: "2",
                            icon: <FileOutlined />,
                            label: (
                                <Link
                                    to={"policies"}
                                    onClick={() => {
                                        setPageTitle("My policies");
                                    }}
                                >
                                    My policies
                                </Link>
                            ),
                        },
                        {
                            key: "3",
                            icon: <UserOutlined />,
                            label: (
                                <Link
                                    to={"me"}
                                    onClick={() => {
                                        setPageTitle("My profile");
                                    }}
                                >
                                    Profile
                                </Link>
                            ),
                        },
                    ]}
                />
            </Sider>
            <Layout 
                className="site-layout"
                style={{
                    marginLeft: isMobile ? 0 : (collapsed ? 80 : 200),
                    transition: "margin-left 0.2s",
                }}
            >
                {!isMobile ? (
                    <Header
                        className="site-layout-background"
                        style={{ 
                            padding: "0 24px",
                            background: "#fff",
                            borderBottom: "1px solid #f0f0f0",
                        }}
                    >
                        {React.createElement(
                            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
                            {
                                className: "trigger",
                                onClick: () => setCollapsed(!collapsed),
                                style: { fontSize: "18px", cursor: "pointer" },
                            }
                        )}
                        <span style={{ marginLeft: "16px" }}>{pageTitle}</span>
                    </Header>
                ) : null}

                <Content
                    className="site-layout-background"
                    style={{
                        margin: isMobile ? "0" : "24px",
                        padding: isMobile ? "16px" : "24px",
                        minHeight: 280,
                        background: "#fff",
                        borderRadius: isMobile ? "8px" : "0px",
                    }}
                >
                    <DashboardContext.Provider
                        value={{
                            pageTitle,
                            setPageTitle,
                        }}
                    >
                        <ErrorBoundary>
                            <Outlet />
                        </ErrorBoundary>
                    </DashboardContext.Provider>
                </Content>
            </Layout>
        </Layout>
    );
}
